import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=55746126&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=js&"
export * from "./Players.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55746126",
  null
  
)

export default component.exports